////////
// Gallery
// - Manages all internal behaviours to do with a image gallery
////////
var Gallery = function(element) {

	this.selectors = {
		top:					".top",
		inner:				".inner",
		paneWrapper: 	".image-panes",
		pane: 				".image-pane",
		controlAll:		".gallery-control",
		controlNext:	"[role='Next']",
		controlPrev:	"[role='Previous']"
	};

	this.flags = {
		ACTIVE: "active"
	};

	this.element = $(element);
	this.content = $(element).parent();
	this.top = this.element.parent().siblings(this.selectors.top).children(this.selectors.inner);
	this.paneWrapper = this.element.children(this.selectors.paneWrapper);
	this.panes = this.element.find(this.selectors.pane);

	// Add controls
	this.content.prepend(
		'<div class="gallery-control btn-page" role="Next"></div>'
		+ '<div class="gallery-control btn-page" role="Previous"></div>'
	);
	this.controlNext = this.content.children(this.selectors.controlNext);
	this.controlNext.on("click", this, this.showNextPane);
	this.controlPrev = this.content.children(this.selectors.controlPrev);
	this.controlPrev.on("click", this, this.showPrevPane);
}


Gallery.prototype.moveToPane = function(fromPane, toPane) {
	if(fromPane.length && toPane.length) {

		// Get the current position
		var x = this.paneWrapper.position().left;

		// Get the new pane position
		var newX = toPane.position().left * -1;

		// Animation
		gsap.to(this.paneWrapper[0], { x: newX, duration: 1 } );

		// Reset active classes
		toPane.addClass(this.flags.ACTIVE);
		fromPane.removeClass(this.flags.ACTIVE);
	}
}


Gallery.prototype.showNextPane = function(e) {
	var obj = e.data;
	var active = obj.paneWrapper.find(obj.selectors.pane + "." + obj.flags.ACTIVE);
	var next = active.next();
	obj.moveToPane(active, next);
}


Gallery.prototype.showPrevPane = function(e) {
	var obj = e.data;
	var active = obj.paneWrapper.find(".active");
	var prev = active.prev();
	obj.moveToPane(active, prev);
}


Gallery.prototype.onGalleryScroll = function() {
	//
}
